var _style, _circle, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs, _path10, _defs2, _path11, _defs3, _path12, _defs4, _path13, _defs5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg23(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#17243F;}\r\n\t.st2{fill:url(#SVGID_1_);}\r\n\t.st3{fill:url(#SVGID_2_);}\r\n\t.st4{fill:url(#SVGID_3_);}\r\n\t.st5{fill:url(#SVGID_4_);}\r\n\t.st6{fill:url(#SVGID_5_);}\r\n\t.st7{fill:url(#SVGID_6_);}\r\n\t.st8{fill:url(#SVGID_7_);}\r\n\t.st9{fill:url(#SVGID_8_);}\r\n\t.st10{fill:url(#SVGID_9_);}\r\n\t.st11{clip-path:url(#SVGID_11_);}\r\n\t.st12{clip-path:url(#SVGID_13_);}\r\n\t.st13{clip-path:url(#SVGID_15_);}\r\n\t.st14{clip-path:url(#SVGID_17_);}\r\n\t.st15{clip-path:url(#SVGID_19_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Calque_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 30,
    cy: 30,
    r: 30
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36,47.3H18.8c-1.3,0-2.3-0.7-2.3-1.8v1.8c0,2.3,1.8,4.2,4.1,4.2c0,0,0.1,0,0.1,0h13.6 c2.3,0.1,4.3-1.8,4.3-4.1c0,0,0,0,0-0.1v-1.8C38.6,46.6,37.3,47.3,36,47.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.3,15.3H20.7c-2.4,0.1-4.3,2-4.3,4.4v2c0.1-1.2,1.1-2.1,2.3-2H36c1.3,0,2.7,1,2.7,2v-2 C38.6,17.3,36.7,15.3,34.3,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36,48.2H18.8c-1.6,0.1-3-1-3.1-2.6V21.7c0.2-1.6,1.5-2.7,3.1-2.6H36c1.6,0,3.4,1,3.4,2.6v23.8 C39.3,47.1,37.6,48.2,36,48.2z M18.8,20.6c-0.9,0-1.6,0.5-1.6,1.1v23.8c0,0.6,0.8,1.1,1.6,1.1H36c1,0,1.9-0.6,1.9-1.1V21.7 c0-0.5-0.9-1.1-1.9-1.1L18.8,20.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.3,52.3H20.7c-2.8,0-5-2.2-5-5V19.7c0-2.8,2.2-5,5-5h13.6c2.8,0,5,2.2,5,5v27.6 C39.3,50.1,37.1,52.3,34.3,52.3C34.3,52.3,34.3,52.3,34.3,52.3z M20.7,16.1c-2,0-3.6,1.6-3.6,3.6v27.6c0,2,1.6,3.6,3.6,3.6 c0,0,0,0,0,0h13.6c2,0,3.6-1.6,3.6-3.6v0V19.7c0-2-1.6-3.6-3.6-3.6L20.7,16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28,18h-1.7c-0.3,0-0.5-0.2-0.5-0.5S26,17,26.3,17H28c0.3,0,0.5,0.2,0.5,0.5S28.3,18,28,18z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.62,
    y1: 50.8051,
    x2: 48.55,
    y2: 50.8051,
    gradientTransform: "matrix(1 0 0 -1 0 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.4,14.7c-0.4,0-0.7-0.4-0.7-0.8c0-0.3,0.3-0.6,0.6-0.7c0.7-0.2,1.4-0.6,1.8-1.3c0.1-0.1,0.1-0.2,0.2-0.4 c0.4-0.7,0.7-1.5,0.8-2.4c0.1-0.9,0.9-1.6,1.8-1.6c1.2,0,2.1,0.9,2.2,2.1c0,0,0,0,0,0.1c0.1,1.1,0,2.2-0.4,3.2h2.3 c0.4,0,0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7l0,0h-4.3l0.3-1c0.4-1.1,0.6-2.3,0.6-3.5c0-0.3-0.2-0.8-0.5-0.9 c-0.2,0-0.3,0-0.4,0.2c-0.1,1.1-0.4,2.1-0.9,3c-0.1,0.1-0.1,0.2-0.2,0.4c-0.6,1.1-1.7,1.8-2.9,2.1L39.4,14.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.84,
    y1: 46.8714,
    x2: 50.32,
    y2: 46.8714,
    gradientTransform: "matrix(1 0 0 -1 0 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M48.3,17.2h-0.4c-0.4,0-0.7-0.4-0.6-0.8c0-0.3,0.3-0.6,0.6-0.6h0.2c0.4,0,0.4,0,0.6-0.1 c0.1-0.2,0.1-0.5,0.1-0.7c0-0.2-0.2-0.3-0.3-0.4c-0.1,0-0.5,0-0.9,0l0,0c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7 c0.4,0,0.8,0,1.2,0.1c0.7,0.2,1.2,0.7,1.4,1.4c0.2,0.7,0,1.5-0.5,2.1C49.4,17,48.9,17.3,48.3,17.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.67,
    y1: 43.8568,
    x2: 49.81,
    y2: 43.8568,
    gradientTransform: "matrix(1 0 0 -1 0 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M48,19.5h-0.2c-0.1,0-0.2,0-0.3,0c-0.4,0-0.8-0.3-0.8-0.7S47,18,47.4,18l0,0h0.4c0.4,0,0.4,0,0.5-0.1 c0.1-0.1,0.1-0.2,0.1-0.3c-0.1-0.4,0.2-0.8,0.6-0.8c0,0,0,0,0,0c0.4,0,0.8,0.2,0.8,0.6c0.1,0.6-0.1,1.2-0.5,1.6 C49,19.3,48.5,19.5,48,19.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.13,
    y1: 41.3592,
    x2: 49.2776,
    y2: 41.3592,
    gradientTransform: "matrix(1 0 0 -1 0 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M47.4,22h-0.2c-0.1,0-0.2,0-0.3,0c-0.4,0-0.8-0.3-0.8-0.7c0-0.4,0.3-0.8,0.7-0.8c0.1,0,0.3,0,0.4,0 c0.4,0,0.4,0,0.5-0.1c0.1-0.1,0.1-0.2,0.1-0.3c-0.1-0.4,0.2-0.8,0.6-0.8c0.4-0.1,0.8,0.2,0.8,0.6c0,0,0,0.1,0,0.1 c0.1,0.5-0.1,1.1-0.5,1.5C48.4,21.8,47.9,22,47.4,22z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.6706,
    y1: 39.1993,
    x2: 48.7506,
    y2: 39.1993,
    gradientTransform: "matrix(1 0 0 -1 0 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M46.9,24h-7.5c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h7.3c0.4,0,0.4,0,0.5-0.1c0-0.1,0.1-0.1,0.1-0.2 c0.1-0.4,0.4-0.7,0.8-0.7c0.4,0,0.7,0.4,0.7,0.8c0,0.4-0.2,0.8-0.5,1.1C47.9,23.8,47.4,24,46.9,24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.8506,
    y1: 48.23,
    x2: 46.4394,
    y2: 48.23,
    gradientTransform: "matrix(1 0 0 -1 0 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M45.7,14.5h-2.1c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h2.1c0.4,0,0.7,0.3,0.7,0.7 C46.4,14.2,46.1,14.5,45.7,14.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.5848,
    y1: 43.27,
    x2: 39.7748,
    y2: 43.27,
    gradientTransform: "matrix(1 0 0 -1 0 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M38.6,24.1h-3.9c-0.7-0.1-1.2-0.7-1.2-1.4c0,0,0,0,0,0v-8c-0.1-0.7,0.5-1.3,1.2-1.4c0,0,0,0,0,0h3.8 c0.7,0.1,1.2,0.7,1.2,1.4c0,0,0,0,0,0v8C39.8,23.4,39.3,24,38.6,24.1z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.52,
    y1: 27.6,
    x2: 33.77,
    y2: 27.6,
    gradientTransform: "matrix(1 0 0 -1 0 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M29.3,43h-7c-0.5,0-0.8-0.4-0.8-0.8V26.6c0-0.5,0.4-0.8,0.8-0.8h10.6c0.5,0,0.8,0.4,0.8,0.8v0v12.9L29.3,43z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.14,
    y1: 27.61,
    x2: 34.1451,
    y2: 27.61,
    gradientTransform: "matrix(1 0 0 -1 0 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M29.4,43.5h-7.3c-0.5,0-0.9-0.4-0.9-0.9V26.2c0-0.5,0.4-0.9,0.9-0.9c0,0,0,0,0,0h11.1c0.5,0,0.9,0.4,0.9,0.9 v13.6c0,0,0,0,0,0.1L29.4,43.5L29.4,43.5z M22.4,25.9c-0.4,0-0.8,0.3-0.8,0.8v15.5c0,0.4,0.3,0.8,0.8,0.8h7l4.4-3.4V26.6 c0-0.4-0.3-0.8-0.8-0.8H22.4z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_10_",
    d: "M29.4,43.5h-7.3c-0.5,0-0.9-0.4-0.9-0.9V26.2c0-0.5,0.4-0.9,0.9-0.9c0,0,0,0,0,0h11.1 c0.5,0,0.9,0.4,0.9,0.9v13.6c0,0,0,0,0,0.1L29.4,43.5L29.4,43.5z M22.4,25.9c-0.4,0-0.8,0.3-0.8,0.8v15.5c0,0.4,0.3,0.8,0.8,0.8 h7l4.4-3.4V26.6c0-0.4-0.3-0.8-0.8-0.8H22.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_11_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_10_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 29,
    height: 31,
    xlinkHref: "83ED3845.png",
    transform: "matrix(1 0 0 1 14.07 20.39)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 31,
    height: 33,
    xlinkHref: "83ED3847.png",
    transform: "matrix(1 0 0 1 13.07 19.39)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.2,43.3L29.2,43.3C29.2,43.3,29.2,43.3,29.2,43.3v-2.9c0-0.5,0.4-0.9,0.9-0.9H34c0,0,0.1,0,0.1,0 c0,0,0,0.1,0,0.1L29.2,43.3L29.2,43.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_12_",
    d: "M29.2,43.3L29.2,43.3C29.2,43.3,29.2,43.3,29.2,43.3v-2.9c0-0.5,0.4-0.9,0.9-0.9H34c0,0,0.1,0,0.1,0 c0,0,0,0.1,0,0.1L29.2,43.3L29.2,43.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_13_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_12_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 16,
    height: 19,
    xlinkHref: "83ED3842.png",
    transform: "matrix(1 0 0 1 22.07 29.39)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.9,29h9.4c0.3,0,0.5-0.2,0.5-0.5c0-0.3-0.2-0.5-0.4-0.5c0,0,0,0,0,0h-9.4c-0.3,0-0.5,0.2-0.5,0.5 c0,0,0,0,0,0C22.4,28.8,22.6,29,22.9,29C22.9,29,22.9,29,22.9,29z"
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_14_",
    d: "M22.9,29h9.4c0.3,0,0.5-0.2,0.5-0.5c0-0.3-0.2-0.5-0.4-0.5c0,0,0,0,0,0h-9.4c-0.3,0-0.5,0.2-0.5,0.5 c0,0,0,0,0,0C22.4,28.8,22.6,29,22.9,29C22.9,29,22.9,29,22.9,29z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_15_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_14_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 15,
    height: 17,
    xlinkHref: "83ED3843.png",
    transform: "matrix(1 0 0 1 22.07 23.39)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.3,32.1h-9.4c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h9.4c0.3,0,0.5-0.2,0.5-0.5S32.6,32.1,32.3,32.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_16_",
    d: "M32.3,32.1h-9.4c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h9.4c0.3,0,0.5-0.2,0.5-0.5S32.6,32.1,32.3,32.1 z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_17_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_16_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 15,
    height: 15,
    xlinkHref: "83ED384D.png",
    transform: "matrix(1 0 0 1 21.07 26.39)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.3,36.1h-9.4c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h9.4c0.3,0,0.5-0.2,0.5-0.5S32.6,36.1,32.3,36.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_18_",
    d: "M32.3,36.1h-9.4c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h9.4c0.3,0,0.5-0.2,0.5-0.5S32.6,36.1,32.3,36.1 z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_19_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_18_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 14,
    height: 16,
    xlinkHref: "83ED384F.png",
    transform: "matrix(1 0 0 1 20.07 27.39)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg23);
export default __webpack_public_path__ + "static/media/23.37dd61fa0240b215aa766eb36ed153c0.svg";
export { ForwardRef as ReactComponent };